import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Alert, Button, Carousel, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import classname from "classname";
import _ from "lodash";

import { useAppSelector } from "hooks/useSelector";
import { setApp } from "redux/configSlice";
import Link from "components/UI/Link";

const AlertsInfo = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { alerts, hideAlert } = useAppSelector();

  const isBillingPage = useMemo(
    () => location.pathname.includes("/settings/billing"),
    [location.pathname]
  );

  const hideAlertHandler = useCallback(() => {
    dispatch(setApp({ hideAlert: true }));
  }, [dispatch]);

  if (_.isEmpty(alerts) || !!hideAlert) {
    return null;
  }

  return (
    <>
      <Carousel
        className="bg-[#ffefb3] mb-5 rounded-lg shadow-lg"
        autoplay={{ dotDuration: true }}
        dots={{
          className: css`
            li button {
              background: rgba(0, 0, 0, 0.5) !important;
            }
            li.slick-active button {
              background: rgba(0, 0, 0, 0.8) !important;
            }
          `,
        }}
        autoplaySpeed={3000}
      >
        {alerts.map((alert, index) => (
          <div
            className="flex flex-row items-start justify-between gap-2"
            key={index}
          >
            <Alert
              className={`text-gray-900 mb-2 bg-[#ffefb3] border-none shadow-none items-start ${css`
                .anticon.anticon-exclamation-circle.ant-alert-icon {
                  margin-top: 5px !important;
                }
              `}`}
              message={
                <div className="flex flex-row items-center gap-2">
                  <Typography.Text className="text-gray-900 text-justify">
                    <Trans
                      defaults={alert?.message || ""}
                      components={{
                        strong: <strong />,
                      }}
                    />
                  </Typography.Text>
                  <div
                    className={classname({
                      hidden:
                        isBillingPage ||
                        alert?.key !== "almost_expired_reminder",
                    })}
                  >
                    <Link to="/settings/billing">
                      {`${t("button.see_more")}...`}
                    </Link>
                  </div>
                </div>
              }
              type="warning"
              showIcon
              closable={false}
            />
            <Button
              type="text"
              className="text-gray-900"
              icon={<CloseOutlined />}
              onClick={hideAlertHandler}
            />
          </div>
        ))}
      </Carousel>
    </>
  );
};

export default AlertsInfo;
